import { getQueryStringValue } from './modules/common-utils.js';
import { resetErrors } from './modules/handle-error.js';
import checkProviders from './modules/check-providers.js';

const changeServiceRedirect = (regionCode) => {
	const url = document.querySelector(
		`meta[name="sumo:login:${regionCode}"]`,
	)?.content;

	document.getElementById('slf-activate').dataset.nextStep = url;
};

/**
 * If you're here looking for the code that clears the signup form on clicking back,
 * there is none. The button is a reset button, and the browser clears the fields itself.
 */
const changeSignup = (current = false) => {
	const pending = document.getElementById('slf-pending');
	const signupStep = document.getElementById('slf-signup');
	const signupIntro = document.getElementById('signup-intro');
	const signupForm = document.querySelector('#slf-signup form');
	const signupInputs = signupForm.querySelectorAll('input');

	resetErrors();

	signupInputs.forEach((el) => {
		el.classList.remove('slf__input-invalid');
		el.classList.remove('slf__email-validated');
	});

	signupStep.removeAttribute('inert');

	switch (true) {
		case current === 'signup':
			signupIntro.setAttribute('inert', true);
			signupForm.removeAttribute('inert');
			break;
		case current === false:
			signupIntro.removeAttribute('inert');
			signupForm.setAttribute('inert', true);
			break;
	}

	pending.setAttribute('inert', true);
};

document.getElementById('signup-option-email').addEventListener('click', () => {
	changeSignup('signup');
});

document.getElementById('signup-flow-back').addEventListener('click', () => {
	changeSignup();
});

document.getElementById('region').addEventListener('change', (e) => {
	const { value } = e.target;
	changeServiceRedirect(value);
});

window.addEventListener('load', (event) => {
	if (!getQueryStringValue('token')) {
		checkProviders().then((response) => {
			const buttons = document.querySelectorAll('button[id^="sso-"]');
			const { oauthProviders } = response;

			if (oauthProviders.length === 0) {
				document.getElementById('signup-flow-back').remove();
				changeSignup('signup');
			} else {
				buttons.forEach((button) => {
					const provider = button.getAttribute('id').split('-')[1];
					if (!oauthProviders.includes(provider)) {
						button.remove();
					}
				});

				changeSignup();
			}
		});
	}
});

document.querySelector('#slf-activate #country').addEventListener('change', (e) => {
	const currentValue = e.target.value;
	const notices = document.querySelectorAll('.consent-notice');

	[...notices].forEach((notice) => {
		const noticeID = notice.getAttribute('id');
		const activeClass = 'consent-notice--active';
		notice.classList.remove(activeClass);

		switch (true) {
			case (currentValue === 'Australia' && noticeID === 'consent-notice-au'):
				notice.classList.add(activeClass);
				break;
			case (currentValue === 'New Zealand' && noticeID === 'consent-notice-nz'):
				notice.classList.add(activeClass);
				break;
			default:
				notice.classList.remove(activeClass);
				break;
		}
	});
});
